<template>
  <div>
    <div class="group d-flex flexy text-white w-100 smallest-font">
      <div v-for="(discount_bar, index) in miles_spend_discount_bars"
           :key="index"
           class="capsule"
           :class="['cp-' + (1 + index), discount_bar.colour]"
      >
        <b-overlay
          :show="discount_bar.locked"
          class="text-center"
          variant="secondary"
          :opacity="0.9"
        >
          <div v-show="!discount_bar.locked" style="height: 100%; display: flex; justify-content: center; align-items: center;">
            {{ (index + 1) * 5 }}%
          </div>
          <template #overlay>
            <div class="text-center">
              <img
                :src="require('@/assets/images/icons/lock_white@2x.png')"
                alt=""
                srcset=""
                class="img-icon"
                style="height: 18px"
              /></div></template
        ></b-overlay>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    spend_discount: {
      default: 5,
    },
    health: {
      default: "yes",
    },
    drive: {
      default: "yes",
    },
    money: {
      default: "Blue",
    },
    account: {
      default: "Suite",
    },
  },
  data (){
    return {
      miles_spend_discount_inputs: [
        true,
        this.drive === 'yes',
        this.health === 'yes'
      ],
      miles_spend_discount_bars : []
    }
  },
  methods : {
    calcMilesSpendDiscountBarColour(miles_spend_discount_type){
      switch (miles_spend_discount_type) {
        case 'health' :
          return 'blue'
        case 'drive' :
          return 'purple'
      }
    },
    calcMilesSpendDiscounts(){

      this.miles_spend_discount_bars = []

      this.miles_spend_discount_bars.push({colour : 'pink', type : 'base', locked : false})

      if(this.health === 'yes'){
        this.miles_spend_discount_bars.push({colour : 'blue', type : 'drive', locked : false})
      }

      if(this.drive === 'yes'){
        this.miles_spend_discount_bars.push({colour : 'purple', type : 'health', locked : false})
      }

      while(this.miles_spend_discount_bars.length < 3){
        this.miles_spend_discount_bars.push({colour : 'grey', type : 'health', locked : true})
      }
    },
  },
  watch :{
    health(newValue, oldValue){
      this.calcMilesSpendDiscounts()
    },
    drive(newValue, oldValue){
      this.calcMilesSpendDiscounts()
    },
  },
  computed : {
    milesSpendDiscounts(){

      return this.miles_spend_discount_inputs.sort((a, b) => Number(b.locked) - Number(a.locked))
    }
  },
  mounted() {
    this.calcMilesSpendDiscounts()
  }
};
</script>

<style lang="scss" scoped>
.capsule {
  background-color: #898a8a;
  height: 25px;
  border-radius: 2em;
  text-align: right;
  padding-right: 0.2em;
  font-size: 1.2em;
  width: 33%;
  &.blue {
    background-color: #1ea4ea;
  }
  &.pink {
    background-color: #ff1c8a;
  }
  &.dark {
    background-color: #004b8d;
  }
  &.purple {
    background-color: #ab47bc;
  }
  &.cp-1 {
    border: 2px solid white;
    position: relative;
    left: 1em;
    z-index: 3;
  }
  &.cp-2 {
    position: relative;
    right: 0em;
    border: 2px solid white;
    z-index: 2;
  }
  &.cp-3 {
    position: relative;
    left: -1em;
    border: 2px solid white;
    z-index: 1;
  }
  &.cp-4 {
    right: 2em;
    z-index: 0;
    position: relative;

    border: 2px solid white;
  }
}
</style>
